import { IconComponentProps } from '../IconTypes';

const ScoreCircleNull = ({ className }: IconComponentProps) => (
  <svg className={className} fill="none" height="14" viewBox="0 0 14 14" width="14" xmlns="http://www.w3.org/2000/svg">
    <circle cx="7.00065" cy="6.99992" r="6.04167" stroke="currentColor" strokeWidth="1.25" />
  </svg>
);

export default ScoreCircleNull;
